import { Component, OnInit } from '@angular/core';
import {NewsletterService} from '../../services/newsletter.service';
import {DestroyComponent} from '../../components/destroy/destroy.component';
import { DataFilterPowiadomieniaService } from 'src/app/services/data-filter-powiadomienia.service';
import {Powiadomienie} from '../../models/powiadomienie.model';
import {NotificationService} from '../../services/notification.service';
import {PowiadomienieFiltr, PowiadomienieFiltrModel} from '../../models/powiadomienie-filtr.model';
import {Observable} from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-powiadomienia',
  templateUrl: './powiadomienia.component.html',
  styleUrls: ['./powiadomienia.component.scss']
})
export class PowiadomieniaComponent extends DestroyComponent implements OnInit {
  model: Powiadomienie[] = [];
  powiadomieniaRequest$: Observable<Powiadomienie[]>;

  constructor(private newsletterService: NewsletterService,
              private dataFilterService: DataFilterPowiadomieniaService,
              private notificationService: NotificationService) {
    super();
  }

  ngOnInit(): void {
    this.dataFilterService.initDataFilter(PowiadomienieFiltr.filtrKey);
    this.subscribeToFilter();
    this.refreshTable();
  }

  subscribeToFilter(): void {
    this.dataFilterService.dataFilter
      .pipe(takeUntil(this.destroy$))
      .subscribe(filter => {
        this.getData(filter);
      });

      this.notificationService.loading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(loading => this.dataFilterService.loading$.next(loading));
  }

  getData(filter: PowiadomienieFiltrModel): void {
    this.powiadomieniaRequest$ = this.notificationService.getFilterNotifications(filter);
  }

   private refreshTable(): void {
    this.newsletterService.selectedTabIndex$
      .pipe(takeUntil(this.destroy$))
      .subscribe(val => {
        if(val == 1) {
          this.getData(this.dataFilterService.dataFilter.getValue() as PowiadomienieFiltrModel);
        }
      });
  }
}
